module.exports = __webpack_public_path__ + "img/image_006.b7aac744.png";